import './hero-banner.scss'
import type { HeroBannerCarouselItem } from '@vista-digital/lumos-cms-client/src/lib/types/custom-content/hero-banner/hero-banner-carousel-item'
import { HeroBannerCarouselItemType } from '@vista-digital/lumos-cms-client/src/lib/types/custom-content/hero-banner/hero-banner-carousel-item-type'
import type { HeroBannerConfiguration } from '@vista-digital/lumos-cms-client/src/lib/types/custom-content/hero-banner/hero-banner-configuration'
import type { SalesChannel } from '@vista-digital/lumos-cms-client/src/lib/types/sales-channel'
import { FilmHeroBannerComponent } from '@vista-digital/occ-ui/src/lib/components/film-hero-banner/film-hero-banner'
import { FilmHeroBannerType } from '@vista-digital/occ-ui/src/lib/components/film-hero-banner/types/props'
import { isEmptyArray } from '@vista-digital/utilities'
import type { FC } from 'react'
import type { CarouselConfig } from '../OccCarousel'
import { OccCarousel } from '../OccCarousel'
import { HeroBannerItemImage } from './hero-banner-item-image'
import { useGetHeroBannerPageProps } from './props'

const componentName = 'HeroBanner'

export interface ExtendedHeroBannerConfiguration extends HeroBannerConfiguration<SalesChannel.Web> {
    carouselConfig: CarouselConfig
}

export const HeroBanner: FC<ExtendedHeroBannerConfiguration> = props => {
    const carouselItems = props.carouselItems ?? []
    const { filmHeroBannerCommonProps } = useGetHeroBannerPageProps(componentName, carouselItems.length)

    if (isEmptyArray(carouselItems)) {
        return null
    }

    const getCarouselItem = (item: HeroBannerCarouselItem<SalesChannel.Web>) => {
        switch (item.type) {
            case HeroBannerCarouselItemType.Film:
                return (
                    <FilmHeroBannerComponent
                        {...filmHeroBannerCommonProps}
                        type={FilmHeroBannerType.Normal}
                        filmId={item.filmId}
                    />
                )
            case HeroBannerCarouselItemType.Image:
                return <HeroBannerItemImage {...item} />
            default:
                throw new Error('Invalid carousel item type')
        }
    }

    return (
        <div className="hero-banner">
            <OccCarousel config={props.carouselConfig}>
                {carouselItems.map((item, index) => (
                    <li key={`carousel-item-${index}`} className="hero-banner__carousel-item">
                        {getCarouselItem(item)}
                    </li>
                ))}
            </OccCarousel>
        </div>
    )
}

HeroBanner.displayName = componentName
